import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import bgImage from "../assets/images/contacthero.png";
import abhi from "../assets/images/abhi.jpeg"
import globe from "../assets/images/globe.png";
import gate from "../assets/images/gate.png";
import stat from "../assets/images/stat.png";
import profile from "../assets/images/profile.jpeg";
import wavebg from "../assets/images/wave.png";


const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};

const AboutPage = () => {
  return (
    <div data-testid="about-page" className="bg-gradient-to-b from-gray-50 to-white" style={{marginTop:"-80px"}}>
      {/* Hero Section */}
      {/* <section className="py-16">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <h1 
                data-testid="about-hero-title"
                className="text-4xl md:text-5xl font-semibold text-gray-900 mb-6"
              >
                About Us
              </h1>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                We are a team of financial experts dedicated to empowering corporates with clarity, confidence, and tailored solutions for sustainable growth.
              </p>
              <p className="text-gray-600 mb-8 leading-relaxed">
                Founded with a vision to simplify corporate finance, we bring together decades of experience in insurance and lending to deliver solutions that truly work for your business.
              </p>
              <Link
                to="/contact"
                data-testid="about-cta-btn"
                className="cta-primary inline-flex items-center gap-2"
              >
                Get in Touch
                <span>›</span>
              </Link>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <img
                src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&q=80"
                alt="Team meeting"
                className="rounded-2xl shadow-lg"
              />
            </motion.div>
          </div>
        </div>
      </section> */}

      {/* Mission Section */}
    <section
        className="relative pt-16 pb-24 bg-cover bg-center"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundPosition: "center bottom",
      }}
    >
      <motion.div
  variants={fadeUp}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
>
      <div className="max-w-5xl mx-auto px-6">

        {/* Heading */}
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-[#2f3a44] text-center">
          Global Experience. Personal Commitment.
        </h2>

        {/* Divider */}
        <div className="w-100 h-[1px] bg-gray-300 mt-6 mb-10"></div>

        {/* Paragraphs */}
       <div className="space-y-10 text-gray-600 text-base md:text-lg leading-8 text-left">

          <p className='text-md leading-10'>
           From leading international trade as an Export Manager to bridging cultures as a bilingual business analyst in Japan, I’ve worked closely with CEOs and CFOs of top global firms. At AIG Japan, I specialized in implementing Ariba solutions, aligning offshore teams with leadership to deliver clarity and efficiency.
          </p>

        <div className="w-full h-[1px] bg-gray-300 "></div>
          <p className='text-md leading-10'>
            <span className="font-semibold text-gray-800">In 2020</span>, my journey expanded into personal investments — deepening my understanding of financial strategy from the inside out. 
            <span className="font-semibold text-gray-800"> On March 15, 2024</span>,
            I founded our financial services firm with a single vision: to empower corporates and entrepreneurs with clarity, confidence, and growth.
          </p>

        <div className="w-100 h-[1px] bg-gray-300"></div>
          <p className='text-md leading-10'>
            Today, I bring together global boardroom expertise, Japanese precision, and a passion for client success — delivering tailored insurance, loan, and funding solutions that inspire trust and drive results.
          </p>

        <div className="w-100 h-[1px] bg-gray-300 mt-6 mb-8"></div>
        </div>
      </div>
      </motion.div>
    </section>

<section
  className="relative py-28 bg-cover bg-center"
  style={{ backgroundImage: `url(${wavebg})` }}
>
  <motion.div
  variants={fadeUp}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
>
  <div className="max-w-6xl mx-auto px-6 relative z-10">

    {/* Floating Profile Image (Overlap Outside + Inside) */}
    <div className="relative md:absolute md:-top-12 md:left-12 z-20 flex justify-center md:block mb-8 md:mb-0">
      <img
        src={abhi}
        alt="profile"
  className="w-[260px] h-[300px] md:w-[360px] md:h-[400px] object-cover rounded-xl shadow-2xl border-4 border-white"
      />
    </div>

    {/* Top Features */}
    {/* <div className="bg-white/90 backdrop-blur-lg rounded-2xl shadow-xl pt-16 pb-10 px-10 border border-gray-200"> */}

      <div className="grid md:grid-cols-5 gap-10 items-center">

  {/* LEFT - Empty space for alignment (since image is absolute) */}
<div className="hidden md:block"></div>
<div className="hidden md:block"></div>

  {/* RIGHT - Features */}
  <div className="md:col-span-3 flex justify-center md:justify-start">
    
    <div className="flex flex-col items-center gap-8 md:flex-row md:gap-10">

      {/* Item 1 */}
      <div className="text-center max-w-[180px]">
        <img src={globe} className="w-36" />
        <h3 className="font-semibold text-gray-800 text-lg">
          Global Expertise
        </h3>
          <div className=" text-center w-30 h-[2px] bg-green-600 my-2"></div>
        <p className="text-sm text-gray-500 mt-1">
          International Trade & Top Executives
        </p>
      </div>

      {/* Item 2 */}
      <div className="text-center max-w-[180px] mt-[-18px]">
        <img src={gate} className="w-36" />
        <h3 className="font-semibold text-gray-800 text-lg">
          Japanese Precision
        </h3>
          <div className="text-center w-30 h-[2px] bg-green-600 my-2"></div>
        <p className="text-sm text-gray-500 mt-1">
          Bilingual & Cultural Insight
        </p>
      </div>

      {/* Item 3 */}
      <div className="text-center max-w-[180px]">
        <img src={stat} className="w-36" />
        <h3 className="font-semibold text-gray-800 text-lg">
          Financial Vision
        </h3>
          <div className="text-center w-30 h-[2px] bg-green-600 my-2"></div>
        <p className="text-sm text-gray-500 mt-1">
          Empowering Growth & Success
        </p>
      </div>

    </div>

  </div>

</div>


      {/* Single Card for Mission + Vision + Philosophy */}
<div className="mt-14 bg-white rounded-2xl border-b-4 border-green-500 p-10 shadow-[0_-10px_30px_rgba(0,0,0,0.15)]">

        {/* Mission & Vision */}
        <div className="grid ml-0 md:ml-64 md:grid-cols-2 divide-y md:divide-y-0 md:divide-x">

          <div className="text-center px-6 py-4">
            <div className="text-green-700 text-3xl mb-2">🎯</div>
            <h3 className="font-semibold text-lg text-gray-800">
              Our Mission
            </h3>
            <div className="w-[180px] h-[2px] my-2 mx-auto bg-gradient-to-r from-transparent via-green-300 to-transparent"></div>
            <p className="text-gray-500 text-sm mt-2">
              Empowering businesses with financial clarity and strategic solutions.
            </p>
          </div>

          <div className="text-center px-6 py-4">
            <div className="text-green-700 text-3xl mb-2">🔭</div>
            <h3 className="font-semibold text-lg text-gray-800">
              Our Vision
            </h3>
            <div className="w-[180px] h-[2px] my-2 mx-auto bg-gradient-to-r from-transparent via-green-300 to-transparent"></div>
            <p className="text-gray-500 text-sm mt-2">
              To be the premier financial partner for corporates, driving growth
              and innovation worldwide.
            </p>
          </div>

        </div>

        {/* Philosophy */}
        <div className="mt-8 pt-6 border-t text-center">
          <h3 className="text-xl font-semibold text-gray-800">
            Our Philosophy
          </h3>
<div className="w-[180px] h-[2px] my-2 mx-auto bg-gradient-to-r from-transparent via-green-300 to-transparent"></div>
          <p className="text-gray-600 mt-3">
            Clarity builds confidence. Strategy drives success. Relationships create results.
          </p>

          <p className="text-gray-500 mt-2">
            We believe in bridging cultures, simplifying finance, and delivering outcomes that matter.
          </p>
        </div>

      </div>

    {/* </div> */}

    {/* CTA */}
    <div className="flex justify-center mt-10">
     <Link to="/contact">
  <button className="bg-green-700 hover:bg-green-800 text-white px-12 py-4 rounded-full shadow-xl transition">
    Get in Touch
  </button>
</Link>
    </div>

  </div>

  </motion.div>
</section>
    </div>
  );
};

export default AboutPage;
